export const queryKeys = {
  reactions: ['reactions'],
}
